<script lang="ts" setup></script>
<template>
  <div class="flex h-screen flex-col">
    <div class="flex-1 overflow-auto px-10 pb-10 pt-8">
      <AccountSession />
    </div>
  </div>
</template>
